export const AnnouncementBehavior = {
  SHOW_EVERY_TIME: 'show_every_time',
  SHOW_ONCE: 'show_once',
  SHOW_ONCE_PER_SESSION: 'show_once_per_session',
};
